export default class PostsFilterBar {
    constructor() {
        this.blogPage = document.querySelector('.blog');
        if (!this.blogPage)
            return;
        this.filterBar = document.querySelector('.news-filter-bar');
        if (!this.filterBar)
            return;
        this.postsContainer = this.blogPage.querySelector('[data-posts]');
        this.categoryContainer = this.filterBar.querySelector('[data-news-category-select]');
        this.categoryItems = this.categoryContainer.querySelectorAll('li');
        this.yearContainer = this.filterBar.querySelector('[data-news-year-select]');
        this.yearItems = this.yearContainer.querySelectorAll('li');
        this.loadTrigger = this.blogPage.querySelector('[data-load-trigger]');
        this.wordpressApiAction = '?action=elko_load_more_posts';
        this.getInfoData();
        this.addEventListeners();
    }
    getInfoData() {
        var _a, _b, _c, _d;
        const postsData = this.loadTrigger.getAttribute('data-load-trigger');
        const dataPairs = postsData.split(',').map(pair => pair.split(':'));
        const dataMap = {};
        dataPairs.forEach(([key, value]) => {
            dataMap[key.trim()] = parseInt(value.trim(), 10);
        });
        this.postsPerPage = (_a = dataMap['ppp']) !== null && _a !== void 0 ? _a : this.postsPerPage;
        this.page = (_b = dataMap['page']) !== null && _b !== void 0 ? _b : null;
        this.category = (_c = dataMap['cat']) !== null && _c !== void 0 ? _c : null;
        this.year = (_d = dataMap['year']) !== null && _d !== void 0 ? _d : null;
        this.setFilterValues();
    }
    setFilterValues() {
        // set category filter from data
        if (this.category) {
            let categoryValue = '';
            this.categoryItems.forEach((category) => {
                category.classList.remove('selected');
                if (category.getAttribute('data-value').toLowerCase() === this.category.toString().toLowerCase()) {
                    category.classList.add('selected');
                    categoryValue = category.innerText;
                }
            });
            this.categoryContainer.querySelector('.custom-select-selected span').textContent = categoryValue;
            this.categoryContainer.querySelectorAll('select option').forEach((option) => {
                const optionItem = option;
                optionItem.selected = optionItem.value.toLowerCase() === this.category.toString().toLowerCase();
            });
        }
        // set year filter from data
        if (this.year) {
            this.yearItems.forEach((year) => {
                year.classList.remove('selected');
                if (year.getAttribute('data-value').toLowerCase() === this.year.toString().toLowerCase()) {
                    year.classList.add('selected');
                }
            });
            this.yearContainer.querySelector('.custom-select-selected span').textContent = this.year.toString().toLowerCase();
            this.yearContainer.querySelectorAll('select option').forEach((option) => {
                const optionItem = option;
                optionItem.selected = optionItem.value.toLowerCase() === this.year.toString().toLowerCase();
            });
        }
    }
    setInfoData(type, value) {
        const postsData = this.loadTrigger.getAttribute('data-load-trigger');
        const dataMap = {};
        postsData.split(',').forEach(pair => {
            const [key, val] = pair.split(':');
            dataMap[key.trim()] = val.trim();
        });
        if (type === 'post_cat') {
            if (value === 'all') {
                delete dataMap['cat'];
            }
            else {
                dataMap['cat'] = value.toString();
            }
        }
        else if (type === 'post_year') {
            if (value === 'all') {
                delete dataMap['year'];
            }
            else {
                dataMap['year'] = value.toString();
            }
        }
        dataMap['page'] = '1';
        this.removePageFromUrl();
        const updatedPostsData = Object.entries(dataMap)
            .map(([key, val]) => `${key}:${val}`)
            .join(',');
        this.loadTrigger.setAttribute('data-load-trigger', updatedPostsData);
    }
    removePageFromUrl() {
        const url = new URL(window.location.href);
        const pathname = url.pathname.replace(/\/page\/\d+/, '');
        const cleanPath = pathname.replace(/\/+$/, '');
        const newUrl = cleanPath + (url.search ? url.search : '');
        window.history.pushState({}, "", newUrl);
    }
    addEventListeners() {
        this.categoryItems.forEach((category) => {
            category.addEventListener('click', (event) => {
                const categoryValue = category.getAttribute('data-value');
                this.setInfoData('post_cat', categoryValue);
                this.setUrl('post_cat', categoryValue);
                this.loadPosts();
            });
        });
        this.yearItems.forEach((year) => {
            year.addEventListener('click', (event) => {
                const yearValue = year.getAttribute('data-value');
                this.setInfoData('post_year', yearValue);
                this.setUrl('post_year', yearValue);
                this.loadPosts();
            });
        });
    }
    setUrl(type, value) {
        const url = new URL(window.location.href);
        if (value === "all") {
            url.searchParams.delete(type);
        }
        else {
            url.searchParams.set(type, value);
        }
        window.history.pushState({}, "", url.toString());
    }
    loadPosts() {
        this.getInfoData();
        const formData = new FormData();
        formData.append('page', this.page.toString());
        formData.append('posts_per_page', this.postsPerPage.toString());
        if (this.category)
            formData.append('category', this.category.toString());
        if (this.year)
            formData.append('year', this.year.toString());
        const options = {
            method: 'POST',
            body: formData
        };
        const ajaxURL = window.localize_script.admin_ajax + this.wordpressApiAction;
        fetch(ajaxURL, options)
            .then(response => response.json())
            .then(response => {
            if (response.success) {
                this.apiResults = response.data.html;
                if (!response.data.has_more) {
                    this.loadTrigger.classList.add('hidden');
                }
                else {
                    this.loadTrigger.classList.remove('hidden');
                }
                this.setDomElements();
            }
        })
            .catch(error => {
            console.error('Fetch error:', error);
        })
            .finally(() => {
            //
        });
    }
    setDomElements() {
        this.postsContainer.innerHTML = this.apiResults;
    }
}
